import { v4 as uuidv4 } from 'uuid'

export interface OauthCustomState {
  appId?: string
  redirectUrl?: string
}

export const generateOauthStateWithAppId = (appId: string): string => {
  return JSON.stringify({
    appId,
    random: uuidv4(),
  })
}

export const generateOauthStateWithUrl = (redirectUrl: string): string => {
  return JSON.stringify({
    redirectUrl,
    random: uuidv4(),
  })
}

// Only https URLs on plume.com (or its subdomains) may be used as post-login redirect targets.
export const isAllowedRedirectUrl = (redirectUrl: string): boolean => {
  try {
    const { protocol, hostname } = new URL(redirectUrl)
    if (protocol !== 'https:') {
      return false
    }
    const host = hostname.toLowerCase()
    return host === 'plume.com' || host.endsWith('.plume.com')
  } catch {
    return false
  }
}

export const generateOauthState = (options: {
  redirectAppId?: string
  redirectUrl?: string
}): string | undefined => {
  if (options.redirectUrl && isAllowedRedirectUrl(options.redirectUrl)) {
    return generateOauthStateWithUrl(options.redirectUrl)
  }
  if (options.redirectAppId) {
    return generateOauthStateWithAppId(options.redirectAppId)
  }
  return undefined
}
